import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUpSquareDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 14.5L12 8.5L18 14.5", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgChevronUpSquareDefault);
export { ForwardRef as ReactComponent };
